import { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const useCategories = (page = 1, perPage = 200) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      setError(null);

      try {
        // ✅ Fetch from your backend API
        const { data } = await axios.get(`${base_url}api/zoho/categories`, {
          params: { page, per_page: perPage },
        });

        if (data && data.categories) {
          setCategories(data.categories);
        } else {
          throw new Error("Invalid response format from categories API");
        }
      } catch (err) {
        console.error("❌ Error fetching categories:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [page, perPage]);

  return { categories, loading, error };
};

export default useCategories;
